import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { BasketProvider } from './contexts/BasketContext';
import { NotificationCountProvider } from './contexts/NotificationCountContext';
import { PopupProvider } from './contexts/PopupContext';
import { SocketProvider } from './contexts/SocketContext';
import { PWAProvider } from './contexts/PWAContext';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // Import Helmet
import Main from './Main';
import theme from './theme';

function App() {
  return (
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <SocketProvider>
              <NotificationCountProvider>
                <BasketProvider>
                  <CurrencyProvider>
                    <PopupProvider>
                      <PWAProvider>
                        <Main />
                      </PWAProvider>
                    </PopupProvider>
                  </CurrencyProvider>
                </BasketProvider>
              </NotificationCountProvider>
            </SocketProvider>
          </AuthProvider>
        </BrowserRouter>
      </ChakraProvider>
    </HelmetProvider>
  );
}

export default App;
